import CabifyImg from '../../../Assets/Cards/cabifyImg.png';
import MonzoImg from '../../../Assets/Cards/monzoImg.png';
import BuzzImg from '../../../Assets/Cards/buzzImg.png';
import HudlImg from '../../../Assets/Cards/hudlImg.png';
import YImg from '../../../Assets/Cards/yImg.png';
import TrusonaImg from '../../../Assets/Cards/trusonaImg.png';
import CookImg from '../../../Assets/Cards/cookImg.png';
import ModeImg from '../../../Assets/Cards/modeImg.png';



import cabifyLogo from '../../../Assets/Cards/cabify.svg';
import monzoLogo from '../../../Assets/Cards/monzo.svg';
import buzzLogo from '../../../Assets/Cards/buzz.svg';
import hudlLogo from '../../../Assets/Cards/hudl.svg';
import yLogo from '../../../Assets/Cards/y.svg';
import trusonaLogo from '../../../Assets/Cards/trusona.svg';
import cookLogo from '../../../Assets/Cards/cook.svg';
import modeLogo from '../../../Assets/Cards/mode.svg';


import profile1 from '../../../Assets/Icons/cprofile1.png';
import profile2 from '../../../Assets/Icons/cprofile2.png';
import profile3 from '../../../Assets/Icons/cprofile3.png';


export const customerCards = [
    {
        Image:CabifyImg,
        logo:cabifyLogo,
        desc:"How Cabify closed design feedback loops to 15 minutes with HostDesign",
        color:"#9870FF",
        delay:100
    },
    {
        Image:MonzoImg,
        logo:monzoLogo,
        desc:"How mozo increased productivity by 30% using Hostdesign’s Handoff tool",
        color:"#E7CE9C",
        delay:200,
        to:"/monzo-increased-productivity"

    },
    {
        Image:BuzzImg,
        logo:buzzLogo,
        desc:"How Buzzfeed's design team created a single source of truth with Hostdesign",
        color:"#FF4F5A",
        delay:300

    }, 
     {
        Image:HudlImg,
        logo:hudlLogo,
        desc:"How Hudl drive great UX through daily user testing with Hostdesign",
        color:"#F2541B",
        delay:400

    }  
    ,{
        Image:YImg,
        logo:yLogo,
        desc:"How Yieldr increased productivity by 30% using Hostdesign’s Handoff tool",
        color:"#2ECC71",
        delay:100

    },
    ,{
        Image:TrusonaImg,
        logo:trusonaLogo,
        desc:"How Cabify closed design feedback loops to 15 minutes with HostDesign",
        color:"#7B46D1",
        delay:200

    },
    ,{
        Image:CookImg,
        logo:cookLogo,
        desc:"How Cabify closed design feedback loops to 15 minutes with HostDesign",
        color:"#FF9933",
        delay:300

    },
    ,{
        Image:ModeImg,
        logo:modeLogo,
        desc:"How Cabify closed design feedback loops to 15 minutes with HostDesign",
        color:"#03B384",
        delay:400

    },
    {
        Image:HudlImg,
        logo:hudlLogo,
        desc:"How Hudl drive great UX through daily user testing with Hostdesign",
        color:"#F2541B",
        delay:100

    } ,
    {
        Image:BuzzImg,
        logo:buzzLogo,
        desc:"How Buzzfeed's design team created a single source of truth with Hostdesign",
        color:"#FF4F5A",
        delay:200

    },
    {
        Image:MonzoImg,
        logo:monzoLogo,
        desc:"How mozo increased productivity by 30% using Hostdesign’s Handoff tool",
        color:"#E7CE9C",
        delay:300

    },
    {
        Image:CabifyImg,
        logo:cabifyLogo,
        desc:"How Cabify closed design feedback loops to 15 minutes with HostDesign",
        color:"#9870FF",
        delay:400

    },

];

export const slides =[
    {
        feedback:"But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer",
        name:"Rene Galindo, Lead Product Designer at Cabify ",
        profile:profile1
    },
    {
        feedback:"But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer",
        name:"Erin Schneider, Lead Product Designer at Cabify  ",
        profile:profile2
    },
    {
        feedback:"But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer",
        name:"Ashley Hunt, Lead Product Designer at Cabify  ",
        profile:profile3
    },
]